var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-loading-bar"},[_c('img',{attrs:{"src":"/img/common/page_loading.svg","alt":"page-loading-bar"}})])}]

export { render, staticRenderFns }